import CryptoJS from 'crypto-js';
import axios from 'axios';
import * as config from '../services/api/config';
import { INIT_DEVICE_SESSION } from '../services/Url';

const DEVICE_KEY_1 = '@sec_k1_snaptoon_web';
const DEVICE_KEY_2 = '@sec_k2_snaptoon_web';

let cachedKey1: string | null = null;
let cachedKey2: string | null = null;

export const getDeviceId = (): string => {
  let id = localStorage.getItem('browser_device_id');
  if (!id) {
    id = 'web_' + Math.random().toString(36).substring(2, 11) + Date.now().toString(36);
    localStorage.setItem('browser_device_id', id);
  }
  return id;
};

export const saveDeviceKeys = (key1: string, key2: string) => {
  cachedKey1 = key1;
  cachedKey2 = key2;
  localStorage.setItem(DEVICE_KEY_1, key1);
  localStorage.setItem(DEVICE_KEY_2, key2);
};

export const getDeviceKeys = () => {
  if (cachedKey1 && cachedKey2) {
    return { key1: cachedKey1, key2: cachedKey2 };
  }
  const k1 = localStorage.getItem(DEVICE_KEY_1);
  const k2 = localStorage.getItem(DEVICE_KEY_2);
  if (k1 && k2) {
    cachedKey1 = k1;
    cachedKey2 = k2;
    return { key1: k1, key2: k2 };
  }
  return null;
};

export async function initDeviceSession(appName = 'SnaptoonWeb'): Promise<boolean> {
  try {
    const deviceId = getDeviceId();
    const url = config.API_URL + INIT_DEVICE_SESSION;
    const response = await axios.post(
      url,
      { d_id: deviceId, app_name: appName, name: appName },
      {
        headers: {
          'Content-Type': 'application/json',
          'ngrok-skip-browser-warning': '69420',
        },
      }
    );

    if (response.data && response.data.key1 && response.data.key2) {
      saveDeviceKeys(response.data.key1, response.data.key2);
      return true;
    }
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.log('Device security handshake failed:', error);
    }
  }
  return false;
}

export async function decryptPayload(encryptedBase64: string): Promise<any> {
  const keys = getDeviceKeys();
  if (!keys) {
    throw new Error('Device security keys not found');
  }

  const key = CryptoJS.enc.Utf8.parse(keys.key1);
  const iv = CryptoJS.enc.Utf8.parse(keys.key2);

  const bytes = CryptoJS.AES.decrypt(encryptedBase64, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);
  if (!decryptedStr) {
    throw new Error('Payload decryption returned empty output');
  }

  try {
    return JSON.parse(decryptedStr);
  } catch (e) {
    return decryptedStr;
  }
}
